import Service from '../../services'
import { checkAndReturn } from "../../main"

const state = {
    FisrtForm: {},
    SecondForm: {},
    ThirdForm: {},
    FourthForm: {},
}

const getters = {

}

const actions = {
    getSpaceRequestsList ({ commit }, params) {
        return Service.Request.getSpaceRequestsList(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    getSpaceRequestsListById ({ commit }, params) {
        return Service.Request.getSpaceRequestsListById(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    createSpaceRequestsForm ({ commit }, params) {
        return Service.Request.createSpaceRequestsForm(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    saveSpaceRequestsForm ({ commit }, params) {
        return Service.Request.saveSpaceRequestsForm(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    updateSpaceRequestsForm ({ commit }, params) {
        return Service.Request.updateSpaceRequestsForm(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    deleteSpaceRequestsForm ({ commit }, params) {
        return Service.Request.deleteSpaceRequestsForm(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    getSpaceRequestsAll ({ commit }, params) {
        return Service.Request.getSpaceRequestsAll(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    formConsider ({ commit }, params) {
        return Service.Request.formConsider(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    getEvaluateAreaList ({ commit }, params) {
        return Service.Request.getEvaluateAreaList(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    changeStatusSpiderChart ({ commit }, params) {
        return Service.Request.changeStatusSpiderChart(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    getSpiderChartPrepareData ({ commit }, params) {
        return Service.Request.getSpiderChartPrepareData(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    sendToConsiderApprove ({ commit }, params) {
        return Service.Request.sendToConsiderApprove(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    storeSpiderChart ({ commit }, params) {
        return Service.Request.storeSpiderChart(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    updateSpiderChart ({ commit }, params) {
        return Service.Request.updateSpiderChart(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    getSpiderChartById ({ commit }, params) {
        return Service.Request.getSpiderChartById(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
    onStamp({ commit }, params) {
        return Service.Request.onStamp(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
}

const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
